import cn from 'classnames'
import React, { ComponentProps } from 'react'
import { useTranslate } from 'src/localization/Trns'

type MccTransportationIconProps = {
  className?: string
} & ComponentProps<'svg'>

export default function MccTransportationIcon(
  props: MccTransportationIconProps,
) {
  const translate = useTranslate()
  const { className = '', ['aria-label']: ariaLabel, ...rest } = props

  return (
    <svg
      className={cn('MccTransportationIcon', className)}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-label={ariaLabel ?? translate('Transportation')}
      {...rest}
    >
      <path
        d="M9.33331 3.66675H10.8915C11.0545 3.66675 11.1361 3.66675 11.2128 3.68517C11.2808 3.7015 11.3459 3.72844 11.4055 3.76499C11.4728 3.80622 11.5304 3.86387 11.6457 3.97917L14.3542 6.68766C14.4695 6.80296 14.5272 6.86061 14.5684 6.92789C14.605 6.98754 14.6319 7.05257 14.6482 7.12059C14.6666 7.19732 14.6666 7.27885 14.6666 7.44191V9.33341C14.6666 9.64404 14.6666 9.79936 14.6159 9.92187C14.5482 10.0852 14.4185 10.215 14.2551 10.2827C14.1326 10.3334 13.9773 10.3334 13.6666 10.3334M10.3333 10.3334H9.33331M9.33331 10.3334V3.80008C9.33331 3.05334 9.33331 2.67998 9.18799 2.39476C9.06016 2.14388 8.85618 1.9399 8.6053 1.81207C8.32009 1.66675 7.94672 1.66675 7.19998 1.66675H3.46665C2.71991 1.66675 2.34654 1.66675 2.06133 1.81207C1.81044 1.9399 1.60647 2.14388 1.47864 2.39476C1.33331 2.67998 1.33331 3.05334 1.33331 3.80008V9.00008C1.33331 9.73646 1.93027 10.3334 2.66665 10.3334M9.33331 10.3334H6.66665M6.66665 10.3334C6.66665 11.438 5.77122 12.3334 4.66665 12.3334C3.56208 12.3334 2.66665 11.438 2.66665 10.3334M6.66665 10.3334C6.66665 9.22884 5.77122 8.33341 4.66665 8.33341C3.56208 8.33341 2.66665 9.22884 2.66665 10.3334M13.6666 10.6667C13.6666 11.5872 12.9205 12.3334 12 12.3334C11.0795 12.3334 10.3333 11.5872 10.3333 10.6667C10.3333 9.74627 11.0795 9.00008 12 9.00008C12.9205 9.00008 13.6666 9.74627 13.6666 10.6667Z"
        stroke="currentColor"
        strokeWidth="1.6"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
